import React from 'react';
import { TopBar } from './../../components/TopBar/TopBar';
import { withRouter } from 'react-router-dom';

import logo from '../../assets/system3-logo.svg'
import { HashLink } from 'react-router-hash-link';
import { Breakpoint } from '../../components/Breakpoint/Breakpoint';
import { cssUrl } from '../../tools/Utils';
class _RouteTopbar extends React.Component
{

	render()
	{
		return (
			<TopBar>
				<div className="composed-logo">
					<img className="floating-logo" src={cssUrl(logo)} />
					<h1> SYSTEM·<span style={{color:"#ff9e00"}} >3</span></h1>
				</div>
				<Breakpoint medium up>
					<ul>
						<li>
							<HashLink to="#marketing" >Marketing</HashLink>
						</li>
						<li>
							<HashLink to="#dev" >Desarrollo</HashLink>
						</li>
						<li>
							<HashLink to="#sat" >SAT</HashLink>
						</li>
					</ul>
				</Breakpoint>
			</TopBar>
		);
	}
}

export const RouteTopbar = withRouter(_RouteTopbar);